<template>
<div>
  <loader v-if="loaderShow"></loader>
  <navbarLogin></navbarLogin>
  <div class="container-fluid" style="overflow: hidden;">
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-2 col-2 pl-0">
        <!-- <img src="../assets/Rectangle.png" class="leftImage" /> -->
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
        <div class="row" style="">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="signup">Login</div>
            <div
              class="getstarted text-left mt-4"
            >Welcome back! Login for seamless, hyperlocal environment data.</div>
            <form>
              <div class="form-group text-left">
                <label>Email Address</label>
                <input
                  v-model="email"
                  type="email"
                  class="form-control input-lg"
                  id="loginEMail"
                  aria-describedby="emailHelp"
                  @change="validateEmail"
                  v-on:keyup.13="login"
                required/>
                <span v-if="!isvalidEmail" id="warningText">*{{emailMessage}}</span>
              </div>
              <div class="text-left form-group">
                <label>Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control input-lg"
                  id="loginPassword"
                  @change="validatePassword"
                  v-on:keyup.13="login"
                required/>
                <span toggle="#password-field" style="color: #BDBDBD;" class="fa mr-2 fa-fw fa-eye field-icon toggle-password"></span>
                <span v-if="!isvalidPassword" id="warningText">*{{passwordMessage}}</span>
                
              </div>
              <span class="already pl-5" @click="routeToForgotPassword">Forgot Password</span>
              <div class="button pt-3 text-left">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                  size="invisible"
                  sitekey="6Ldwtr0UAAAAAF--eORDJK5nF18ydD5tFchWnilY">
                </vue-recaptcha>
                <button type="button"
                        class="btn btn-primary signupbtn"
                        @click="login">Login</button>
                <span class="already" @click="signupRoute">Register</span>
              </div>
              <div class="pt-3" v-if="invalidUser==1">
                <p class="invalid">Email or Password Incorrect</p>
              </div>
            </form>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 d-none d-sm-block img-container">
            <img src="../assets/Group 4.png" class="img-fluid" alt="group 4 img" />
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 mt-auto col-sm-2 col-2" style="max-height: 89vh">
        <!-- <img src="../assets/Path 2.png" class="rightImage" style="pointer-events: none;" /> -->
      </div>
    </div>
  </div></div>
</template>
<script>
import Vue from 'vue'
import $ from 'jquery'
import VueRecaptcha from 'vue-recaptcha'
import Toasted from 'vue-toasted'
import { AUTH_REQUEST } from '../store/actions/auth'
import loader from './loader'
import navbarLogin from './navbarLogin'

Vue.use(Toasted)
export default {
  data() {
    return {
      sitekey: process.env.RECA_KEY,
      loaderShow: false,
      email: '',
      password: '',
      isvalidEmail: true,
      isvalidPassword: true,
      emailMessage: '',
      passwordMessage: '',
      hidePassword: true,
      invalidUser: 0,
      status: ''
    }
  },
  mounted:() => {
    $('.toggle-password').click(() => {
      $('.toggle-password').toggleClass('fa-eye fa-eye-slash')
      if ($('#loginPassword').attr('type') === 'password') {
        $('#loginPassword').attr('type', 'text')
      } else {
        $('#loginPassword').attr('type', 'password')
      }
    })
  },
  components: { VueRecaptcha, navbarLogin, loader },
  methods: {
    routeToForgotPassword() {
      this.$router.push('/forgot-password')
    },
    signupRoute() {
      this.$router.push('/signup')
    },
    pushToForgotPassword() {
      this.$router.push('/forgot-password')
    },
    onCaptchaVerified(recaptchaToken) {
      this.loaderShow = true
      const self = this
      self.status = 'submitting'
      self.$refs.recaptcha.reset()
      const email = this.email
      const password = this.password
      this.$store.dispatch(AUTH_REQUEST, { email, password, recaptchaToken })
        .then(() => {
          this.$router.push('/dash')
          self.status = ''
        })
        .catch((error) => {
          console.log('error', error)
          this.loaderShow = false
          this.invalidUser = 1
        })
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    validateEmail() {
      /* eslint-disable */
      // use regex for email validation properly
      var field = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // var failedValidation = this.email.indexOf('@') === -1
      if (!field.test(this.email)) {
        this.isvalidEmail = false
        this.emailMessage = 'Please enter a valid email address.'
        $('#loginEMail').css('border-color','red')
      } else {
        this.isvalidEmail = true
        $('#loginEMail').css('border-color','#ced4da')
        // this.isEmail = true
      }
      // this.message = ''
    },
    validatePassword() {
      /* eslint-disable */
      // alert(field.test(this.password))
      if (this.password === '') {
        this.isvalidPassword = false
        this.passwordMessage = 'Password is a required field'
        $('#password').css('border-color', 'red')
      } else {
        this.isvalidPassword = true
        $('#password').css('border-color', '#ced4da')
      }
    },
    pushToregister() {
      this.$router.push('/signup')
    },
    login() {
      if(!this.isvalidEmail || !this.isvalidPassword) {
        this.validateEmail()
        this.validatePassword()
        this.$toasted.show('Please enter valid Inputs', { duration: 1500 })
        return
      } else {
        this.$refs.recaptcha.execute()
      }
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 34em) {
  .rightImage {
    margin-left: -160px !important;
  }
  .button {
    display: grid;
  }
}
.signup {
  font-family: "Ubuntu";
  font-weight: 700;
  font-size: 38px;
  text-align: left;
  margin-top: 10%;
}
.getstarted,.invalid {
  opacity: 0.7;
  font-family: "Ubuntu";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
label {
  font-family: "Ubuntu";
  font-weight: 400;
  font-size: 12px;
  color: #606060;
  padding-left: 5px;
  padding-right: 5px;
}
.signupbtn {
  background: #2295c8;
  border-radius: 30px;
  width: 108px;
  height: 44px;
  font-family: "Ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  border: none;
}

.signupbtn:hover {
  background: #2295c8;
}
.img-container {
  margin-top: 12%;
  width: 100%;
}
.form-group > label {
  position: relative;
  left: 19px;
  top: 15px;
  background: white;
}
.input {
  padding-top: 2px;
  font-family: ubuntu;
  font-weight: 300;
  color:white;
}

@media only screen and (max-width: 600px) {
  .already {
    margin-left: 5% !important;
  }

}
.already {
  font-family: "Ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #2295c8;
  line-height: 20px;
  margin-left: 57%;
  cursor: pointer;
}
#warningText {
  font-size: 12px;
  font-family: "Ubuntu";
}
.leftImage {
  transform: rotate(180deg);
  /* margin-top: -270px; */
  margin-top: -270px;
  margin-left: -29px;
}
.rightImage {
  -webkit-transform: rotateY(218deg);
  position: fixed;
  bottom: -52px;
  right: -44px;
  /* margin-left: -21px;
  margin-bottom: -46px; */
}
.navbarLinkClass {
  font-family: "Ubuntu";
  font-size: 14px;
  color: rgba(0,0,0,0.50);
  text-align: left;
}
.active {
  font-family: "Ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #2295C8;
  text-align: left;
  }

.field-icon {
  float: right;
  margin-left: -25px;
  margin-top: -25px;
  position: relative;
}
</style>
